import { AxiosPromise } from 'axios';
import Http from '../../shared/http';
import {
  OpenSearchLogDTO,
  OpenSearchLogFilterCriteriaDTO,
  API_PATH_LOGS,
  API_PATH_EXPORT_LOGS,
  API_PATH_FILTER_OPTIONS,
  GetOpenSearchLogFilterValuesDTO,
} from './log.types';
import { ServerResponse } from '../types';

const http = Http.getHttp();

export function getLogs(
  size: number,
  from: number,
  criteria: OpenSearchLogFilterCriteriaDTO
): AxiosPromise<ServerResponse<OpenSearchLogDTO>> {
  return http.post(`${API_PATH_LOGS}`, criteria, {
    params: {
      size,
      from
    }
  });
}

export function exportLogs(
  criteria: OpenSearchLogFilterCriteriaDTO
): AxiosPromise<BlobPart> {
  return http.post(`${API_PATH_EXPORT_LOGS}`, criteria, {
    responseType: 'blob'
  });
}

export function getFilterOptions(
  criteria: OpenSearchLogFilterCriteriaDTO
): AxiosPromise<ServerResponse<GetOpenSearchLogFilterValuesDTO>> {
  return http.post(`${API_PATH_FILTER_OPTIONS}`, criteria);
}
